import { useMutation, useQuery } from "@apollo/client";
import {
  Button,
  Card,
  Drawer,
  Group,
  LoadingOverlay,
  Modal,
  ScrollArea,
  useMantineTheme,
} from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import EditIcon from "@mui/icons-material/Edit";
import { DEL_SUPPLIER_PAYOUT } from "apollo/mutuations";
import { GET_SUPPLIERS_PAYOUTS } from "apollo/queries";
import ActionButton from "components/controls/ActionButtonNew";
import TotalAmount from "components/controls/TotalAmount";
import SupplierAddPayout from "components/payout/addPayout";
import SupplierUpdatePayout from "components/payout/updatPayout";
import B2bTable from "components/reusable/b2bTable";
import { customLoader } from "components/utilities/loader";
import { useEffect, useState } from "react";
import { FiEye } from "react-icons/fi";
import { Trash } from "tabler-icons-react";
import ExportComponent from "utiles/export";
import { formatNumber } from "utiles/url";
import Payouts from "./Payout";
import SupplierFilter from "./supplier";
const SupplierPayout = ({ isSme = false }) => {
  const [size, setSize] = useState("10");
  const [openedDelete, setOpenedDelete] = useState(false);
  const [openedEdit, setOpenedEdit] = useState(false);
  const [openedDetail, setOpenedDetail] = useState(false);
  const [detailUserName, setDetailUserName] = useState(null);
  const [detailTotalAmount, setDetailTotalAmount] = useState(null);
  const [user, setUser] = useState(null);
  const [editId, setEditId] = useState();
  const [opened, setOpened] = useState(false);
  const [deleteID, setDeleteID] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [activePage, setActivePage] = useState(1);
  const [total, setTotal] = useState(0);

  const { data, loading, refetch } = useQuery(GET_SUPPLIERS_PAYOUTS, {
    variables: {
      supplier_id: user?.value,
      first: parseInt(size),
      page: activePage,
      search: searchValue,
      is_sme: isSme,
      ordered_by: [
        {
          column: "CREATED_AT",
          order: "DESC",
        },
      ],
    },
    onError(error) {
      showNotification({
        color: "red",
        title: "Error",
        message: error?.graphQLErrors?.[0]?.message || "Failed to Get payouts",
      });
    },
  });

  const handlePageSizeChange = (newSize) => {
    setSize(newSize);
    setActivePage(1);
  };
  useEffect(() => {
    if (data) {
      setTotal(data.supplierPayouts.paginatorInfo.lastPage);
    }
  }, [data, size]);
  useEffect(() => {
    refetch();
  }, [refetch]);

  const headerData = [
    {
      label: "Name",
      key: "supplier.user.name",
      sortable: false,
      searchable: true,
      width: "20%",
      render: (rowData) => {
        return <span>{rowData.supplier.user.name}</span>;
      },
    },
    {
      label: "Phone",
      key: "supplier.user.phone",
      sortable: false,
      searchable: true,
      render: (rowData) => {
        return <span>{rowData.supplier.user.phone}</span>;
      },
    },
    {
      label: "Email",
      key: "supplier.user.email",
      sortable: false,
      searchable: true,
      render: (rowData) => {
        return <span>{rowData.supplier.user.email}</span>;
      },
    },
    {
      label: "Amount",
      key: "amount",
      sortable: false,
      searchable: false,
      render: (rowData) => {
        return <span>{formatNumber(rowData.total_payout)}</span>;
      },
    },
    {
      label: "Actions",
      key: "actions",
      sortable: false,
      searchable: false,
      render: (rowData) => {
        return (
          <div style={{ width: "150px", display: "flex", gap: "6px" }}>
            <ActionButton
              label="View"
              color="success"
              onClick={() => handleViewDetails(rowData)}
            >
              <FiEye fontSize="medium" />
            </ActionButton>
            <ActionButton label="Edit" onClick={() => handleEditUser(rowData)}>
              <EditIcon style={{ fontSize: "1rem" }} />
            </ActionButton>
            <ActionButton
              color="error"
              label="Delete"
              onClick={() => handleDelete(`${rowData.id}`)}
            >
              <Trash size={17} />
            </ActionButton>
          </div>
        );
      },
    },
  ];
  const handleViewDetails = (rowData) => {
    setEditId(rowData.payouts);
    setDetailUserName(rowData.supplier?.user?.name || null);
    setDetailTotalAmount(rowData.total_payout ?? null);
    setOpenedDetail(true);
  };
  const handleDelete = (id) => {
    setOpenedDelete(true);
    setDeleteID(id);
  };

  const handleEditUser = (id) => {
    setOpenedEdit(true);
    setEditId(id);
  };

  const handleChange = (currentPage) => {
    setActivePage(currentPage);
  };

  const [confirmedSearch, setConfirmedSearch] = useState("");

  const handleManualSearch = (searchTerm) => {
    setSearchValue(searchTerm);
  };
  const clearInput = () => {
    setSearchValue("");
    setConfirmedSearch("");
  };

  const theme = useMantineTheme();

  const [delCategory] = useMutation(DEL_SUPPLIER_PAYOUT, {
    update(cache, { data: { deleteSupplierPayout } }) {
      cache.updateQuery(
        {
          query: GET_SUPPLIERS_PAYOUTS,
          variables: {
            supplier_id: user,
            first: parseInt(size),
            page: activePage,
            search: "",
            is_sme: isSme,
            ordered_by: [
              {
                column: "CREATED_AT",
                order: "DESC",
              },
            ],
          },
        },
        (data) => {
          if (data.supplierPayouts.data.length === 1) {
            setTotal(total - 1);
            setActivePage(activePage - 1);
          } else {
            return {
              supplierPayouts: {
                data: [
                  ...data.supplierPayouts.data.filter(
                    (category) => category.id !== deleteSupplierPayout.id,
                  ),
                ],
              },
            };
          }
        },
      );
    },
  });

  const deleteBusines = () => {
    delCategory({
      variables: { id: deleteID },
      onCompleted(data) {
        setOpenedDelete(false);
        setDeleteID(null);
        showNotification({
          color: "green",
          title: "Success",
          message: "Business Deleted Successfully",
        });
      },
      onError(error) {
        showNotification({
          color: "red",
          title: "Error",
          message:
            error?.graphQLErrors?.[0]?.message || "Failed to Delete Payout",
        });
      },
    });
  };
  return loading ? (
    <LoadingOverlay
      visible={loading}
      color="blue"
      overlayBlur={2}
      loader={customLoader}
    />
  ) : (
    <div style={{ width: "98%", margin: "auto" }}>
      <Drawer
        opened={opened}
        onClose={() => setOpened(false)}
        title="Addding a Payout"
        padding="xl"
        size="80%"
        position="bottom"
        overlayColor={
          theme.colorScheme === "dark"
            ? theme.colors.dark[9]
            : theme.colors.gray[2]
        }
        overlayOpacity={0.55}
        overlayBlur={3}
      >
        <SupplierAddPayout
          size={size}
          activePage={activePage}
          setOpened={setOpened}
        />
      </Drawer>
      <Drawer
        opened={openedDetail}
        onClose={() => setOpenedDetail(false)}
        padding="xl"
        size="80%"
        position="bottom"
        overlayColor={
          theme.colorScheme === "dark"
            ? theme.colors.dark[9]
            : theme.colors.gray[2]
        }
        overlayOpacity={0.55}
        overlayBlur={3}
      >
        <Payouts
          ordersList={editId}
          userName={detailUserName}
          totalAmount={detailTotalAmount}
        />
      </Drawer>

      <Drawer
        opened={openedEdit}
        onClose={() => setOpenedEdit(false)}
        title="Editing Business"
        padding="xl"
        size="80%"
        position="bottom"
        overlayColor={
          theme.colorScheme === "dark"
            ? theme.colors.dark[9]
            : theme.colors.gray[2]
        }
        overlayOpacity={0.55}
        overlayBlur={3}
      >
        <SupplierUpdatePayout
          id={editId}
          setOpenedEdit={setOpenedEdit}
          supplierPayout={editId}
        />
      </Drawer>
      <Modal
        opened={openedDelete}
        onClose={() => setOpenedDelete(false)}
        title="Warning"
        centered
      >
        <p>Are you sure do you want todelete this supplier payout?</p>
        <Group position="right">
          <Button onClick={() => deleteBusines()} color="red">
            Delete
          </Button>
        </Group>
      </Modal>
      <Card shadow="sm" p="lg">
        <ScrollArea>
          <B2bTable
            total={total}
            activePage={activePage}
            handleChange={handleChange}
            header={headerData}
            clearInput={clearInput}
            filterData={({ onCardClick }) => (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "16px",
                }}
              >
                <SupplierFilter
                  setActivePage={setActivePage}
                  user={user}
                  onCardClick={setUser}
                  isSme={isSme}
                />
                <ExportComponent
                  data={data ? data.supplierPayouts.data : []}
                  headers={headerData.filter(
                    (header) => header.key !== "actions",
                  )}
                  reportTitle={
                    isSme ? "SME Payouts Report" : "Supplier Payouts Report"
                  }
                  filterSubtitle={`${
                    user?.label
                      ? `${isSme ? "SME Supplier" : "Supplier"}: ${user.label}`
                      : isSme
                        ? "All SME Suppliers"
                        : "All Suppliers"
                  }${searchValue ? `, Search: ${searchValue}` : ""}`}
                  fileNamePrefix={
                    isSme
                      ? "sme_supplier_payouts_report"
                      : "supplier_payouts_report"
                  }
                />
              </div>
            )}
            handelSearch={handleManualSearch}
            searchValue={confirmedSearch}
            searchInput={false}
            onSearchChange={setConfirmedSearch}
            loading={loading}
            layout={{ minWidth: 700 }}
            data={data ? data.supplierPayouts.data : []}
            size={size}
            handlePageSizeChange={handlePageSizeChange}
          />
          <TotalAmount
            amount={data ? data.supplierPayouts.total_supplier_payouts : 0}
          />
        </ScrollArea>
      </Card>
    </div>
  );
};

export default SupplierPayout;
